import { useIsVenue } from '@hooks/use-is-venue';
import {
	getPriceRangeText,
	isExtendedPriceRangeSchemaExperimentEnabled,
} from '@pages/Storefront/utils/extendedPriceRangeSchemaExperiment';
import { useAppSelector } from '@redux/hooks';
import { useAtomValue } from 'jotai/index';
import type { Decorated } from 'types/vendor';
import { detailedPricingStartingCostAtom } from '../../../jotai/storefront/detailed-pricing';
import {
	startingCostAtom,
	venueEstimateUsuallySpendAtom,
} from '../../../jotai/storefront/pricing';

export const useStorefrontDisplayPriceRange = (): string | null => {
	const vendor = useAppSelector((state) => state.vendor.vendor as Decorated);
	const startingCost = useAtomValue(
		useIsVenue() ? startingCostAtom : detailedPricingStartingCostAtom,
	);
	const estimatedPrice = useAtomValue(venueEstimateUsuallySpendAtom);
	let priceRangeDisplay = null;
	if (isExtendedPriceRangeSchemaExperimentEnabled(vendor.displayId)) {
		if (startingCost) {
			priceRangeDisplay = getPriceRangeText(startingCost);
		} else if (estimatedPrice) {
			priceRangeDisplay = getPriceRangeText(estimatedPrice);
		}
	}
	return priceRangeDisplay;
};
